// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zJOZ","type":"styles_type__29xE9","choices":"styles_choices__2LfbV"};